<template>
<div class="wrapper">
    <div class="container">

        <div class="enter-password q-py-xl q-px-lg">
            
            <p class="q-my-lg">We have sent a password reset code to the email id you entered. Enter it below to reset your password.</p>
            <input type="text" v-html="error_code" class="code q-my-sm" v-model="code" placeholder="Code">
            
            <p v-if="is_code_error" class="text-negative">* Please enter a valid reset code</p>
            <p v-if="is_code_valid" class="text-positive">* Reset code is valid</p>

            <input type="text" v-html="error_password" class="code q-my-sm" v-model="password" placeholder="Password">

            <p v-if="is_password_error" class="text-negative">* Password should be 6 to 15 characters which contain at least one numeric digit and a special character</p>
            <p v-if="is_password_valid" class="text-positive">* Password is valid</p>

            <input type="password" v-html="error_confirm_password" class="code q-my-sm" v-model="confirm_password" placeholder="Confirm Password">

            <p v-if="is_confirm_password_error" class="text-negative">* Password not matching</p>
            <p v-if="is_confirm_password_valid" class="text-positive">* Password is confirmed</p>


            <input type="submit" class="submit q-my-sm" @click="reset_password()" value="Reset my password">

        </div>


    </div>

</div>

</template>
<script>
import awsconfig from "../aws-exports";
import { Auth } from "aws-amplify";
Auth.configure(awsconfig);

export default {
    data() {
        return{
            api_url: this.$store.state.API_URL[process.env.VUE_APP_ENV],
            username:this.$store.state.forgot_password_email,

            code:'',
            password:'',
            confirm_password:'',

            is_code_valid:false,
            is_code_error:false,
            is_password_valid:false,
            is_password_error:false,
            is_confirm_password_valid:false,
            is_confirm_password_error:false,

        }

        
    },
    computed:{

        error_code(){
            var regex = /^\d{6}$/gm;
 
     

            if(regex.test(this.code))
            {
                this.is_code_valid = true;
                this.is_code_error = false;
                
                return '';


            }
            else if(this.code.length <4){
                this.is_code_valid = false;
                this.is_code_error = false;
                
                return '';

            }
            else
            {
                this.is_code_valid = false;
                this.is_code_error = true;
                return "";

            }

        },
        error_password() {

      var regex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,15}$/;

            if(regex.test(this.password))
            {
                this.is_password_valid = true;
                this.is_password_error = false;
                
                return '';


            }
            else if(this.password.length <6){
                this.is_password_valid = false;
                this.is_password_error = false;
                
                return '';

            }
            else
            {
                this.is_password_valid = false;
                this.is_password_error = true;
                return "";

            }

      

    },
    error_confirm_password() {

        if(this.confirm_password.length<6)
        {
            this.is_confirm_password_valid = false;
            this.is_confirm_password_error = false;
                
                return '';

        }
        else if(this.password != this.confirm_password){
            this.is_confirm_password_valid = false;
            this.is_confirm_password_error = true;
                
                return '';

        }
        else{
            this.is_confirm_password_valid = true;
            this.is_confirm_password_error = false;
                
                return '';

        }

    },

    },

    methods:{
        reset_password(){
            // Collect confirmation code and new password, then

            if(this.is_code_error || this.is_password_error || this.is_confirm_password_error)
            {
                this.$alert("Please enter proper credentials and try again","Could not reset", "error");

            }

             this.$q.loading.show({
                message: 'Processing your request, please wait..'
            
            });

            Auth.forgotPasswordSubmit(this.username, this.code, this.password)
                .then(data =>{
                    console.log(data);
                    this.$q.loading.hide();
                    this.code="";
                    this.password="";
                    this.confirm_password="";
                    this.$confirm("Your password has been reset successfully","Great!", "success").then(() => {
                        
                        if(process.env.VUE_APP_ENV == "development") window.location.href = "http://localhost:8080/"
                        else if(process.env.VUE_APP_ENV == "test") window.location.href = "https://app-test.uniqin.ai/"
                        else if(process.env.VUE_APP_ENV == "production") window.location.href = "https://app.uniqin.ai/"
                        
                    });

                } 
                
                )
                .catch(err => {
                    console.log(err);
                    this.$q.loading.hide();

                    this.$alert("Could not change password","Error occured", "error");
                
                });

        }
    }
}
</script>

<style scoped>
    .wrapper{
        height: 89.2vh;
    }
    .container{
        height: 100%;
        display:flex;
        justify-content: center;
        align-items:center;
    }
    .enter-password{
        width:400px;
        height:auto;
        box-shadow: 0 5px 15px rgba(0,0,0,.5);
        

    }

    .enter-password input{
        width: 100%;
        height: 36px;
         border-radius: 4px;
         outline:none;
          border:1.5px solid #d0d0d0;
           padding-left:10px;
         
    }

   
    .enter-password .submit{
        background-color: #175293 !important;
        border: none;
        color: white;
        cursor: pointer;
       
    }

    .enter-password .submit:hover{
        background-color: #073a70;
        
    }
</style>